import React from "react";
import { ButtonProps } from "../Button";
import { PaginationItem } from "./PaginationItem";
export const PaginationMore = <E extends React.ElementType = "button">(
  props: ButtonProps<E> & {
    current?: boolean;
  },
) => {
  return (
    <PaginationItem disabled {...props}>
      <div>...</div>
    </PaginationItem>
  );
};
